module.exports = __webpack_public_path__ + "img/yellow.be5030ca.webp";